export default __webpack_public_path__ + "maps-examples-user-location-annotation-1200-16c9c58dacea57dd2d5d47c2a44f5873.png";